import type { FaqEntry } from '../types/content';

export const faqs: FaqEntry[] = [
  {
    id: 'who-can-join',
    question: 'Who can join Bates Taekwondo?',
    answer:
      'Bates Taekwondo teaches Olympic-style Taekwondo for ages 3 through adult. Kids, teens and adults are all welcome, and beginners can start in a class suited to their age and experience.',
  },
  {
    id: 'little-braves-age',
    question: 'How old do children need to be for Little Braves?',
    answer: 'Little Braves is for children ages 3 to 5. Older children join Kids Taekwondo.',
  },
  {
    id: 'trial',
    question: 'Can we try a class before signing up?',
    answer:
      'Yes. Your first class is a free trial class. Call (505) 985-9091, email batestkd@gmail.com, or request a trial online to set it up.',
  },
  {
    id: 'contracts',
    question: 'Do I have to sign a contract?',
    answer:
      'No. Bates Taekwondo has no required contracts. Memberships include unlimited weekday classes in the applicable program; Competition Team training is a separate pathway.',
  },
  {
    id: 'competition',
    question: 'Does my child have to compete?',
    answer:
      'No. Beginner and general classes focus on skills, fitness and personal progress. The Competition Team is an additional option for committed athletes who want to compete.',
  },
  {
    id: 'schedule',
    question: 'What is the class schedule?',
    answer:
      'Classes run on weekdays. Because the schedule can change, contact the school and ask which current class suits your age and experience.',
  },
  {
    id: 'gear',
    question: 'What should we wear or bring?',
    answer:
      'Ask the school when you book your free trial. They will let you know what to bring for your first class and what gear your program uses.',
  },
];
